// @flow

import type {ApplicationState} from '../../types'
import type {PlaceState} from '../types'

export function getPlace(appState: ApplicationState): ?ServiceProvider{
  return _getPlace(appState.place) 
}

function _getPlace(state: PlaceState): ?ServiceProvider{
  return state.place
}

getPlace.internal = _getPlace
